import { render, staticRenderFns } from "./Deep.vue?vue&type=template&id=1808d18a"
import script from "./Deep.vue?vue&type=script&lang=js"
export * from "./Deep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports